// Header account dropdown (<details-disclosure> fallback variant in snippets/header-account.liquid):
// open on hover instead of click. The panel (.header__account-modal) is a CHILD of the
// <details-disclosure> wrapper, so one pointerenter/pointerleave pair covers icon + panel — but the
// panel sits at `top: calc(100% + 2rem)`, so the pointer leaves the wrapper while crossing that
// ~20px gap; a short grace timer keeps it open for the dive. Mouse only — touch/keyboard keep the
// native <summary> toggle (and Motto's Escape / outside-click close in assets/details-disclosure.js).
const CLOSE_GRACE_MS = 200;

document
  .querySelectorAll('.header__account details-disclosure')
  .forEach((disclosure) => {
    const details = disclosure.querySelector('details');
    if (!details) return;

    let closeTimer = null;

    disclosure.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    });

    disclosure.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => disclosure.close(), CLOSE_GRACE_MS);
    });
  });
